import {
  Box,
  Button,
  Dialog,
  Paper,
  TextField,
  Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { HexColorPicker } from 'react-colorful';
import { useTranslation } from 'react-i18next';

const ExoColorPicker = ({
  color = '#ffffff',
  open,
  onClose = () => {},
  onSelect = () => {},
}) => {
  const { t } = useTranslation();

  const [selectedColor, setSelectedColor] = useState(color || '#ffffff');

  useEffect(() => {
    setSelectedColor(color || '#ffffff');
  }, [color]);

  function handleColorChange(hex) {
    if (hex === '#NaNNaNNaN') return;

    setSelectedColor(hex);
  }

  function handleSelect() {
    onSelect(selectedColor);
    onClose();
  }

  return (
    <Dialog open={open} onClose={onClose}>
      <Paper className="flex flex-col justify-center items-center gap-4 p-4">
        <Typography variant="h3">{t('Pick a Color')}</Typography>
        <HexColorPicker color={selectedColor} onChange={handleColorChange} />
        <TextField
          label="HEX-Code"
          value={selectedColor}
          onChange={(e) => {
            let value = e.target.value;

            // Remove all non-hex characters and leading '#'s
            value = value.replace(/[^0-9A-Fa-f]/g, '');

            // Limit to 6 hex digits max
            value = value.slice(0, 6);

            // Always prefix with '#'
            const formattedValue = '#' + value;

            handleColorChange(formattedValue);
          }}
        />

        <Box className="flex flex-row justify-between w-full gap-4">
          <Button onClick={onClose} variant="outlined" color="error">
            {t('Cancel')}
          </Button>
          <Button variant="contained" onClick={handleSelect} color="success">
            {t('Select')}
          </Button>
        </Box>
      </Paper>
    </Dialog>
  );
};

export default ExoColorPicker;
